import React from 'react';
import cx from 'classnames';

import { CircleIcon, FontAwesomeIcon } from '@magoosh/lib/icons';
import { ColorPalette } from 'types/constants';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  colorPalette: ColorPalette;
  navigate?: (stepIdx: number) => void;
  steps?: {
    active: boolean;
    complete: boolean;
    name: string;
    navigable: boolean
  }[];
}

const StepIndicators: React.FC<Props> = (props) => {
  const nonActiveColorPalette = { dark: colors.textColor, light: colors.grayLighter };

  const canNavigateToStep = (stepIdx) => {
    if (!props.navigate) return false;
    if (!props.steps[stepIdx].navigable) return false
    if (props.steps[stepIdx].active) return false;

    return true;
  }

  return (
    <div className="align-items-center d-flex gap-xs">
      {
        props.steps?.map((step, idx) => {
          const stepIcon = (
            <CircleIcon
              bordered={step.complete || step.active}
              colorPalette={step.active ? props.colorPalette : nonActiveColorPalette}
              size={35}
            >
              {
                step.complete ? (
                  <FontAwesomeIcon icon="check" style={{ WebkitTextStroke: `1px ${props.colorPalette.light}` }} />
                ) : idx + 1
              }
            </CircleIcon>
          );

          return (
            <React.Fragment key={idx}>
              {
                canNavigateToStep(idx) ? (
                  <a
                    className="text-hover-no-decoration text-no-decoration"
                    onClick={() => props.navigate(idx + 1)}
                  >
                    {stepIcon}
                  </a>
                ) : (
                  stepIcon
                )
              }

              {
                idx !== props.steps.length - 1 && (
                  <div
                    className="bg-gray-lighter u-margin-V-xxs"
                    style={{ minHeight: 2, width: 15 }}
                  />
                )
              }
            </React.Fragment>
          );
        })
      }
    </div>
  );
};

export default StepIndicators;
